import { useTheme } from "../context/ThemeProvider";

const LOGO_LIGHT = "https://breel.ink/uploads/main/9a00d6288352c4140833cb6b68afc844.png";
const LOGO_DARK = "https://breel.ink/uploads/main/e19cc8e02b669984e9cdbd62920c90fc.png";

export const BrandLogo = ({ className = "", eager = false, ...props }) => {
  const { theme } = useTheme();
  const src = theme === "dark" ? LOGO_DARK : LOGO_LIGHT;
  return (
    <img
      src={src}
      alt="BREELINK"
      className={`w-auto object-contain select-none ${className}`}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      draggable={false}
      {...props}
    />
  );
};
